import { render, staticRenderFns } from "./basicinstrumentList.vue?vue&type=template&id=12c66543&scoped=true"
import script from "./basicinstrumentList.vue?vue&type=script&lang=js"
export * from "./basicinstrumentList.vue?vue&type=script&lang=js"
import style0 from "./basicinstrumentList.vue?vue&type=style&index=0&id=12c66543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c66543",
  null
  
)

export default component.exports